var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M13.4,3.8l-1.31,1.38l3.73,3.95H10.6C7.52,9.14,5,11.8,5,15.06v5.14h1.87v-5.14c0-2.17,1.68-3.95,3.73-3.95\nh5.23l-3.73,3.95l1.31,1.38l5.32-5.63c0.37-0.39,0.37-1,0-1.38L13.4,3.8L13.4,3.8z"}})}
var staticRenderFns = []

export { render, staticRenderFns }